/**
 * Icons för DQFleet
 * Använder Heroicons istället för FontAwesome Pro
 */

import {
  TruckIcon,
  ChartBarIcon,
  MapIcon,
  UserIcon,
  MagnifyingGlassIcon,
  BellIcon,
  MoonIcon,
  SunIcon,
  BookOpenIcon,
} from '@heroicons/react/24/outline';
import {
  TruckIcon as TruckIconSolidFilled,
  ChartBarIcon as ChartBarIconSolidFilled,
  MapIcon as MapIconSolidFilled,
  UserIcon as UserIconSolidFilled,
  BookOpenIcon as BookOpenIconSolidFilled,
} from '@heroicons/react/24/solid';

// Navigation icons
export const fleetIcon = <TruckIcon className="w-5 h-5" />;
export const fleetIconSolid = <TruckIconSolidFilled className="w-5 h-5" />;
export const statisticsIcon = <ChartBarIcon className="w-5 h-5" />;
export const statisticsIconSolid = <ChartBarIconSolidFilled className="w-5 h-5" />;
export const tripsIcon = <MapIcon className="w-5 h-5" />;
export const tripsIconSolid = <MapIconSolidFilled className="w-5 h-5" />;
export const userIcon = <UserIcon className="w-5 h-5" />;
export const userIconSolid = <UserIconSolidFilled className="w-5 h-5" />;

// Action icons - exportera komponenterna direkt
export { MagnifyingGlassIcon, BellIcon, MoonIcon, SunIcon, BookOpenIcon };

// Legacy exports för bakåtkompatibilitet - använder text-current för att ärva färg
export const searchIcon = <MagnifyingGlassIcon className="w-5 h-5 text-textSecondary" />;
export const notificationIcon = <BellIcon className="w-5 h-5 text-textSecondary" />;
export const moonIcon = <MoonIcon className="w-5 h-5 text-teal-600 dark:text-teal-400" />;
export const sunIcon = <SunIcon className="w-5 h-5 text-amber-500 dark:text-amber-400" />;
export const manualIcon = <BookOpenIcon className="w-5 h-5 text-textSecondary" />;
export const manualIconSolid = <BookOpenIconSolidFilled className="w-5 h-5 text-textSecondary" />;
